import React, { useState } from "react";
import { Card, Text, Button, Stack, Modal } from "@mantine/core";
import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import entityIcon from "@util/entityIcon";
import entityColor from "@util/entityColor";
import { UserGroupForm } from "./";

export default function UserGroupCreate({
  buttonProps = {
    variant: "light",
    size: "sm",
  },
  modalProps = {
    title: "Create Segment",
  },
  // here we can pass in props to the form like title, description
  formProps = {
    name: "My Segment",
    description: "A simple description of the segment",
  },
  reqData = {
    // location_id
    // organization_id
    // report_snapshot_id
    // report_recipe_id
    // campaign_effort_id
  },
}) {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <Button
        {...buttonProps}
        leftSection={entityIcon.userGroup(16)}
        color={entityColor.user}
        onClick={() => setOpen(true)}
      >
        Create Segment
      </Button>
      <Modal {...modalProps} opened={open} onClose={() => setOpen(false)}>
        <UserGroupForm
          info={formProps}
          reqData={reqData}
          onSuccess={() => {
            setOpen(false);
          }}
        />
      </Modal>
    </div>
  );
}
